// extracted by mini-css-extract-plugin
module.exports = {"challengeProgress":"ChallengeProgress_challengeProgress__39PGd"};